import { useContext } from "react";
import { AuthContext } from "../Context/AuthContext";

const SessaoAuth = () => {
  const { sessao, setSessao } = useContext(AuthContext);
  return { sessao, setSessao };
};

export default SessaoAuth;
